export default "__VITE_ASSET__82088eb0__"